import { ReactComponent as OpenExternalIcon } from "@common/assets/images/external-open-icon.svg";
import { vars } from "@common/styles";
import styled from "styled-components";

export const Card = styled.div`
  width: 44rem;
  padding: 2rem;
  border-radius: 1rem;
  border: 1px solid ${vars.colors.grey90};
  background-color: ${vars.colors.grey100};
  box-shadow: 0 2px 10px 0 #1c1c1e;
  z-index: ${vars.zIndex.modalContent};
  user-select: none;
`;

export const LearnMore = styled.button`
  display: flex;
  align-items: center;
  gap: 1rem;

  margin-top: 2.4rem;
  padding: 1rem 2rem;
  border: 1px solid ${vars.colors.grey80};
  background-color: ${vars.colors.grey90};
  border-radius: 1rem;

  color: ${vars.colors.white};
  font-family: inherit;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0;
  outline: none;
  cursor: pointer;
  transition: ${vars.transitions.hover};

  &:hover,
  &:focus-visible {
    border-color: ${vars.colors.grey70};
    background-color: ${vars.colors.grey80};

    svg path {
      stroke: ${vars.colors.white};
    }
  }
`;

export const ExternalIcon = styled(OpenExternalIcon)`
  width: 1.6rem;
  height: 1.6rem;
`;
